<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <AlarmTableButton ref='alarmTableButton' @notice='notice' @keywords='changeKeywords'></AlarmTableButton>
        <AlarmTable ref='alarmTable'></AlarmTable>
      </div>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import AlarmTableButton from '../../components/alarmconfig/alarmRedirect/AlarmRedirectTableButton';
import AlarmTable from '../../components/alarmconfig/alarmRedirect/AlarmRedirectTable';

export default {
  name: 'AlarmRedirectPage',
  components: {
    BasicLayout,
    AlarmTableButton,
    AlarmTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.alarmRedirect')}`
      }
    };
  },
  methods: {
    changeKeywords(args) {
      this.$refs.alarmTable.queryConditions.keywords = args;
    },
    notice(type) {
      switch (type) {
        case 'refresh':
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'redefine': // 重定义
          this.$refs.alarmTable.showType = 1;
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'queryLTE': // 宽带查询
          this.$refs.alarmTable.showType = 3;
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'edit':
          this.$refs.alarmTable.editFunc();
          break;
        case 'reset':
          this.$refs.alarmTable.resetFunc();
          break;
        default:
      }
    }
  }
};
</script>